interface LogoProps {
  variant?: 'full' | 'icon-only' | 'text-only';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export default function Logo({ variant = 'full', size = 'md', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'h-10',
    md: 'h-16',
    lg: 'h-24',
    xl: 'h-64 w-64',
  };

  // Try SVG first, then PNG
  const logoPath = '/logo.svg';

  if (variant === 'text-only') {
    return (
      <div className={`font-display font-bold text-primary-600 ${className}`}>
        <span className="text-primary-500">Story</span>
        <span className="text-secondary-500">
          <span className="text-emerald-500">S</span>prout
        </span>
      </div>
    );
  }

  if (variant === 'icon-only') {
    return (
      <div className={`${className}`}>
        <img
          src={logoPath}
          alt="StorySprout"
          className={`${sizeClasses[size]} object-contain`}
          onError={(e) => {
            // If image fails to load, hide it
            e.currentTarget.style.display = 'none';
          }}
        />
      </div>
    );
  }

  // Full logo with image and text
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={logoPath}
        alt="StorySprout Logo"
        className={`${sizeClasses[size]} object-contain`}
        onError={(e) => {
          // If image fails to load, show text logo only
          const parent = e.currentTarget.parentElement;
          if (parent) {
            parent.innerHTML = `
              <div class="font-display font-bold text-2xl">
                <span class="text-primary-500">Story</span>
                <span class="text-secondary-500">
                  <span class="text-emerald-500">S</span>prout
                </span>
              </div>
            `;
          }
        }}
      />
    </div>
  );
}
